(function () {
  'use strict';

  function removeAttributes(element, attributes) {
    attributes.forEach(function (attribute) {
      element.removeAttribute(attribute);
    });
  }

  function normalizeSlick(root, label) {
    var slider = root && root.jquery ? root[0] : root;
    if (!slider || !slider.classList.contains('slick-initialized')) return;

    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-roledescription', 'carousel');
    if (!slider.getAttribute('aria-label')) {
      slider.setAttribute('aria-label', label || 'Content carousel');
    }

    var track = slider.querySelector('.slick-track');
    if (track) {
      removeAttributes(track, [
        'role',
        'aria-label',
        'aria-live',
        'aria-atomic',
        'aria-activedescendant'
      ]);
    }

    var originalSlides = Array.prototype.filter.call(
      slider.querySelectorAll('.slick-slide'),
      function (slide) {
        return !slide.classList.contains('slick-cloned');
      }
    );

    slider.querySelectorAll('.slick-slide').forEach(function (slide) {
      removeAttributes(slide, [
        'aria-controls',
        'aria-describedby',
        'aria-selected'
      ]);

      if (slide.classList.contains('slick-cloned')) {
        slide.removeAttribute('role');
        slide.removeAttribute('aria-label');
        slide.removeAttribute('aria-roledescription');
        return;
      }

      var slideIndex = originalSlides.indexOf(slide);
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'slide');
      if (slideIndex > -1) {
        slide.setAttribute(
          'aria-label',
          'Slide ' + (slideIndex + 1) + ' of ' + originalSlides.length
        );
      }
    });

    var dots = slider.querySelector('.slick-dots');
    if (dots) {
      dots.removeAttribute('role');
      dots.querySelectorAll('li').forEach(function (item, index) {
        removeAttributes(item, [
          'role',
          'aria-controls',
          'aria-hidden',
          'aria-selected',
          'tabindex'
        ]);

        var button = item.querySelector('button, a');
        if (!button) return;

        removeAttributes(button, ['role', 'aria-controls', 'aria-selected']);
        button.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        if (item.classList.contains('slick-active')) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }

    var previous = slider.querySelector('.slick-prev');
    var next = slider.querySelector('.slick-next');
    if (previous && !previous.getAttribute('aria-label')) {
      previous.setAttribute('aria-label', 'Previous slide');
    }
    if (next && !next.getAttribute('aria-label')) {
      next.setAttribute('aria-label', 'Next slide');
    }
  }

  function normalizeAllSlick() {
    document.querySelectorAll('.slick-initialized').forEach(function (slider) {
      normalizeSlick(slider);
    });
  }

  window.AGFNA11y = window.AGFNA11y || {};
  window.AGFNA11y.normalizeSlick = normalizeSlick;

  if (window.jQuery) {
    window.jQuery(document).on(
      'init.agfnA11y reInit.agfnA11y afterChange.agfnA11y breakpoint.agfnA11y',
      '.slick-slider',
      function () {
        var slider = this;
        window.setTimeout(function () {
          normalizeSlick(slider);
        }, 0);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeAllSlick, {
      once: true
    });
  } else {
    normalizeAllSlick();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(normalizeAllSlick, 0);
  });
})();
